export const allEmptyTextValues = [
  '<p><br></p>',
  '<h1><br></h1>',
  '<h2><br></h2>',
  '<h3><br></h3>',
  '<h4><br></h4>',
]
